import { useQuery } from "@apollo/client";
import { CCard, CCardBody, CCardHeader, CCardTitle, CCol, CRow } from "@coreui/react-pro";
import { useParams } from "react-router-dom";
import { VIEW_ID_DEFINITION } from "../../../graphql/queries/linked-id";
import CreateLinkingID from "./Components/CreateLinkingID";
import DisplayLinkingIDS from "./Components/DisplayLinkingIDs";
import DynamicLinkDefinitionModal from "./Components/DynamicLinkDefinitionModal";

const DEFAULT_DATA = {
  LinkingIDDefinition: { name: "LOADING", description: "", id: "", slug: "", LinkingIDs: [] },
};

const ViewLinkDefinition = () => {
  const { linkDefinitionId } = useParams();

  const {
    data = DEFAULT_DATA,
    data: {
      LinkingIDDefinition: { name, description, id, slug, LinkingIDs },
    } = DEFAULT_DATA,
    refetch,
    loading,
  } = useQuery(VIEW_ID_DEFINITION, {
    skip: !linkDefinitionId,
    variables: {
      id: linkDefinitionId,
    },
  });

  return (
    <>
      <CCard>
        <CCardHeader>
          <CCardTitle>
            {name} <span className={"smaller text-secondary"}>{slug}</span>
          </CCardTitle>
        </CCardHeader>
        <CCardBody>
          <CRow className={"mb-2"}>
            <CCol xs={2}>Description</CCol>
            <CCol>{description ?? <em>No description given</em>}</CCol>
          </CRow>
          <CRow>
            <CCol>
              <DynamicLinkDefinitionModal
                initialValues={data.LinkingIDDefinition}
                onComplete={() => void refetch()}
              />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      <CCard className={"mt-2"}>
        <CCardHeader>
          <CCardTitle>Linked IDs</CCardTitle>
        </CCardHeader>
        <CCardBody>
          <DisplayLinkingIDS linkingIDs={LinkingIDs} onChange={() => void refetch()} />
        </CCardBody>
        <CCardBody>
          <CreateLinkingID definition={data.LinkingIDDefinition} onFinish={() => void refetch()} />
        </CCardBody>
      </CCard>
    </>
  );
};

export default ViewLinkDefinition;
